import React from "react"
import config from 'react-global-configuration';

import AuthStore from '../../stores/AuthStore'
import AuthActions from '../../actions/AuthActions';
import MemberActions from '../../actions/MemberActions';
import MemberStore from '../../stores/MemberStore'


/*
var getInvoiceState = () => {
  return InvoiceStore.getAll()
}
*/

export default class Header extends React.Component {

  constructor(){
    super()
    AuthActions.setAuth()
    this.memberStoreChangeHandler = this.memberStoreChangeHandler.bind(this)
    this.state = {
      item:null
    }
  }

  componentDidMount(){
    //console.log(AuthStore.getToken())
    MemberStore.addChangeListener(this.memberStoreChangeHandler)
    MemberActions.getDetail(AuthStore.getToken())
  }

  componentWillUnmount(){
      MemberStore.removeChangeListener(this.memberStoreChangeHandler)
  }

  /* Handlers */

  memberStoreChangeHandler(){
    const member = MemberStore.getDetail()
    if(member.customer == "live"){
      this.setState({
        item:member
      })
    }else{
      //console.log("to payment")
      window.location = "/club/payment"
    }


  }

  render(){
    if(!this.state.item ){
      return null
    }



    return(
      <div className="header-info">{this.state.item.name} 様 <span className="black">|</span> 会員番号:{this.state.item.id}</div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/components/parts/Header.js